export const DEFAULT_PERFORMANCE_MARK_NAMESPACE = 'SPA';
export const PERFORMANCE_MARK_SSR_START = 'SSR_START';
export const PERFORMANCE_MARK_SSR_HTML = 'SSR_HTML';
export const PERFORMANCE_MARK_SSR_STYLES = 'SSR_STYLES';
